import ApplicationController from "./application_controller";

// Merker, um den Fokus + Cursor-Position über den Turbo-Drive-Reload hinweg
// wiederherzustellen. Ohne das verliert ein Volltextfilter beim Absenden den
// Fokus und man kann nicht weitertippen (AT-Bug "kommt nicht über 3 Zeichen").
const FOCUS_KEY = "search-filter:refocus"

export default class extends ApplicationController {
    static get targets() {
        return ["form"]
    }

    connect() {
        super.connect();
        this.#restoreFocus()
    }

    submit(event) {
        this.#rememberFocus(event && event.target)
        this.formTarget.requestSubmit()
    }

    debounced(event) {
        clearTimeout(this._debounceTimer)
        const field = event && event.target
        this._debounceTimer = setTimeout(() => {
            this.#rememberFocus(field)
            this.formTarget.requestSubmit()
        }, 600)
    }

    // Feldname + Cursor merken, damit der Fokus nach dem Reload zurückkehrt.
    #rememberFocus(field) {
        if (!field || !field.name) return
        try {
            sessionStorage.setItem(FOCUS_KEY, JSON.stringify({
                name: field.name,
                start: field.selectionStart,
                end: field.selectionEnd,
                t: Date.now()
            }))
        } catch (_) { /* sessionStorage nicht verfügbar -> ignorieren */ }
    }

    #restoreFocus() {
        let raw
        try { raw = sessionStorage.getItem(FOCUS_KEY) } catch (_) { return }
        if (!raw) return
        try { sessionStorage.removeItem(FOCUS_KEY) } catch (_) { /* noop */ }

        let data
        try { data = JSON.parse(raw) } catch (_) { return }
        if (!data || !data.name || (Date.now() - data.t) > 3000) return

        const field = this.formTarget.querySelector(`[name="${CSS.escape(data.name)}"]`)
        if (!field) return

        field.focus()
        if (typeof data.start === "number" && field.setSelectionRange) {
            try { field.setSelectionRange(data.start, data.end != null ? data.end : data.start) } catch (_) { /* noop */ }
        }
    }
}
